import { STATE_ABBREVIATION } from "../../constants";
import { formatDate } from "../../utils";

export type RfpFile = {
  name: string;
  lastModified: string | Date;
  [key: string]: unknown;
};

export type ParsedRfpFile = RfpFile & {
  displayName: string;
  loading: boolean;
  lastModified: string;
};

export function parseUploadedFiles(
  rfpFiles: RfpFile[] | null | undefined,
): ParsedRfpFile[] {
  return (
    rfpFiles?.map((f) => {
      const tokens = f.name.split("/");
      return {
        ...f,
        displayName: tokens[tokens.length - 1],
        lastModified: formatDate(f.lastModified),
        loading: false,
      };
    }) ?? []
  );
}

export interface AddressInfo {
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
}

export function buildAddress(
  clientInfo: AddressInfo | null | undefined,
  no_info = "N/A",
): string {
  if (!clientInfo) {
    return no_info;
  }
  const formatted = buildFormattedAddress(clientInfo);
  if (formatted.length === 0) {
    return no_info;
  }
  return `${formatted[0]} ${formatted[1]}`;
}

type BuildFormattedAddressOptions = {
  isStateAbbreviation?: boolean;
  hasValidation?: boolean;
};

export function buildFormattedAddress(
  clientInfo: AddressInfo | null | undefined,
  {
    isStateAbbreviation = false,
    hasValidation = true,
  }: BuildFormattedAddressOptions = {},
): string[] {
  const { addressLine1, addressLine2, city, state, zipCode } = clientInfo || {};

  if (hasValidation && (!addressLine1 || !city || !state || !zipCode)) {
    return [];
  }
  const address = [addressLine1, addressLine2].filter(Boolean).join(", ");
  const formattedState =
    isStateAbbreviation && state
      ? (STATE_ABBREVIATION as Record<string, string>)[state] || state
      : state;

  const stateZip = [formattedState, zipCode].filter(Boolean).join(" ");
  const secondLine = [city, stateZip].filter(Boolean).join(", ");
  return [address, secondLine];
}

export { formatDate };
